import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
	selector: '[ellipsisText]' ,
})
export class EllipsisFinderDirective {

    constructor(public el: ElementRef, public renderer: Renderer2) {}
    ngAfterViewInit(){
        if(this.el.nativeElement.scrollWidth <= this.el.nativeElement.clientWidth){
            this.renderer.addClass(this.el.nativeElement, 'tooltip-block');
      	}
    }
}